import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import BrandAssetsManager from "../../components/BrandAssets/BrandAssetsManager";
import { apiService } from "../../service/Api";

/**
 * Onboarding Step 2 - Brand Assets Setup
 * Uses the reusable BrandAssetsManager component
 */
export default function OnboardingStep2New() {
  const navigate = useNavigate();
  const { checkAuthStatus } = useAuth();

  const handleSaveAndContinue = async (assets) => {
    // Navigate to step 3 (user intelligence)
    navigate("/tailspin/onboarding/step3");
  };

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(to bottom right, rgba(255, 107, 90, 0.1), #F8F7F4, rgba(215, 180, 114, 0.1))' }}>
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{ backgroundColor: 'rgba(215, 180, 114, 0.15)' }}>
            <CheckCircle className="w-8 h-8" style={{ color: '#D7B472' }} />
          </div>
          <h1 className="text-4xl font-bold mb-3" style={{ color: '#0A0A10' }}>
            Almost There!
          </h1>
          <p className="text-xl mb-2" style={{ color: '#0A0A10', opacity: 0.7 }}>
            Step 2: Configure Your Brand Assets
          </p>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="w-8 h-8 rounded-full text-white flex items-center justify-center text-sm" style={{ backgroundColor: '#FF6B5A' }}>
              <CheckCircle className="w-5 h-5" />
            </div>
            <div className="w-16 h-1" style={{ backgroundColor: '#FF6B5A' }}></div>
            <div className="w-8 h-8 rounded-full text-white flex items-center justify-center text-sm font-semibold" style={{ backgroundColor: '#FF6B5A' }}>
              2
            </div>
            <div className="w-16 h-1" style={{ backgroundColor: '#D7B472', opacity: 0.5 }}></div>
            <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold" style={{ backgroundColor: '#D7B472', opacity: 0.3, color: '#0A0A10' }}>
              3
            </div>
          </div>
        </div>

        {/* Brand Assets Manager */}
        <BrandAssetsManager 
          onSave={handleSaveAndContinue}
          showSaveButton={false}
        />

        {/* Navigation */}
        <div className="flex justify-between mt-8">
          <button
            onClick={() => navigate("/tailspin/onboarding/step1")}
            className="px-8 py-3 rounded-lg font-medium text-lg transition-colors"
            style={{ backgroundColor: '#D7B472', opacity: 0.3, color: '#0A0A10' }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.5'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.3'; }}
          >
            ← Back to Products
          </button>
          <button
            onClick={handleSaveAndContinue}
            className="px-8 py-3 text-white rounded-lg font-medium text-lg transition-colors flex items-center gap-2"
            style={{ backgroundColor: '#FF6B5A' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e55a4a'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#FF6B5A'; }}
          >
            Continue to Intelligence →
          </button>
        </div>
      </div>
    </div>
  );
}

